import { render, staticRenderFns } from "./hamburger.vue?vue&type=template&id=893465b8&scoped=true"
import script from "./hamburger.vue?vue&type=script&lang=js"
export * from "./hamburger.vue?vue&type=script&lang=js"
import style0 from "./hamburger.vue?vue&type=style&index=0&id=893465b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893465b8",
  null
  
)

export default component.exports